import React from 'react'
import Rating from 'react-rating'

import { Star } from 'phosphor-react'
import { Row } from 'components/v2/Grid'
import { Text } from 'components/v2/Text'

const getEvaluationsCount = psycho =>
  typeof psycho.evaluations === 'number'
    ? psycho.evaluations
    : psycho.evaluationsCount
    ? psycho.evaluationsCount
    : typeof psycho.evaluations === 'object'
    ? psycho.evaluations.length
    : 0

const renderAggregatedMeta = psycho => {
  const tags = []
  tags.push(<meta itemprop='ratingValue' content={psycho.rating?.total || 0}></meta>)
  tags.push(<meta itemprop='bestRating' content='5'></meta>)
  tags.push(<meta itemprop='worstRating' content='0'></meta>)
  tags.push(<meta itemprop='reviewCount' content={getEvaluationsCount(psycho)}></meta>)
  return tags
}

const Evaluation = ({ psycho, numbertotal, isAggregatedReview, notShowNumber }) => {
  const evaluationsCount = getEvaluationsCount(psycho)
  const hasEvaluation = evaluationsCount > 0
  return (
    <Row
      alignItems='center'
      justifyContent='flex-start'
      minHeight={20}
      itemProp='aggregateRating'
      itemScope={true}
      itemType='http://schema.org/AggregateRating'
    >
      {isAggregatedReview && hasEvaluation && renderAggregatedMeta(psycho)}
      <Row width='max-content' alignItems='center' justifyContent='flex-start'>
        <Rating
          initialRating={numbertotal}
          fractions={2}
          start={0}
          stop={5}
          readonly={true}
          emptySymbol={<Star size={18} weight='regular' color='#D9D9D9' />}
          fullSymbol={<Star size={18} weight='fill' color='#FF7708' />}
        />
      </Row>
      {!notShowNumber && psycho.evaluations > 0 && (
        <Text fontSize='12px' ml='8px' color='primary'>
          {evaluationsCount > 0 && `(${evaluationsCount})`}
        </Text>
      )}
    </Row>
  )
}

export default Evaluation
